import { Injectable } from '@angular/core';
import { db } from '../db';
import { LastSuccessfulSynchronization } from '../models/last-successful-synchronization';
import { BaseRepository } from './base.repository';

@Injectable({
  providedIn: 'root',
})
export class LastSuccessfulSynchronizationRepository extends BaseRepository<
  LastSuccessfulSynchronization,
  string
> {
  constructor() {
    super(db.lastSuccessfulSynchronizations, 'userEmail');
  }

  async getLatest(userEmail: string): Promise<LastSuccessfulSynchronization | undefined> {
    return await this.getById(userEmail);
  }

  async saveLatest(summary: LastSuccessfulSynchronization): Promise<string> {
    await this.table.put(summary);
    return summary.userEmail;
  }
}
